<div *ngIf="dayType" class="day-type-name">
	{{ dayType }}
	<ng-content></ng-content>
</div>
